import { render, staticRenderFns } from "./ResultadosWindowLI.vue?vue&type=template&id=750b3aee&scoped=true&"
import script from "./ResultadosWindowLI.vue?vue&type=script&lang=js&"
export * from "./ResultadosWindowLI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b3aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
